

















import { computed, defineComponent, onMounted, PropType, ref, watch } from "@vue/composition-api";
import { PurchasedItem } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import useClampingView from "@/hooks/useClampingView";
import { getElement } from "@/lib/elementHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseButton from "@/components/BaseButton";
import WysiwygViewer from "@/components/WysiwygViewer";
import usePurchasedItem from "@/views/PagePurchaseGallery/hooks/usePurchasedCover";
import PurchasedItemBase from "../../components/PurchasedItemBase.vue";

export default defineComponent({
  name: "RichTextPostView",
  components: { BaseButton, WysiwygViewer, PurchasedItemBase },
  props: {
    item: { type: Object as PropType<PurchasedItem>, required: true },
  },
  setup(props) {
    const {
      clampingComponent: wysiwyg,
      expanded,
      styleHeight,
      clampOnMount,
      showHeightToggle,
      toggleExpanded,
    } = useClampingView();
    const contentElement = ref();

    const { coverFile } = usePurchasedItem(props.item);

    const coverStyle = computed(() => {
      if (coverFile.value) {
        const background = MediaFilesController.getImageThumbnail(coverFile.value.urlPart, "1080p");
        return { "--backgroundImage": `url(${background})` };
      }
      return {};
    });

    watch(expanded, value => {
      if (!value) {
        getElement<HTMLElement>(contentElement.value).scrollIntoView({
          block: "start",
          behavior: "smooth",
        });
      }
    });

    onMounted(() => {
      clampOnMount();
    });

    return { contentElement, coverFile, coverStyle, expanded, styleHeight, showHeightToggle, wysiwyg, toggleExpanded };
  },
});
